import axiosInstance from '../axiosInterceptor/axiosInstance'

const deleteGroup = async ({ orgId, groupId }) => {
  const url = `v1/orgs/${orgId}/groups/${groupId}`
  const response = await axiosInstance.delete(url)
  return response?.data
}

export default deleteGroup
